/**
 * [Overlay description]
 * @type {Object}
 */
const Overlay = {
  /**
   * [overlay description]
   * @param  {Object} whereThrow [description]
   * @param  {String} colorStyle [description]
   * @return {[type]}            [description]
   */
  addTo (whereThrow, colorStyle) {
    let colorClassName = ''
    switch (colorStyle) {
      case 'light':
        colorClassName = 'light'
        break
      case 'dark':
        colorClassName = 'dark'
        break
      case 'grey':
        colorClassName = 'grey'
        break
      case 'blue':
        colorClassName = 'blue'
        break
      case 'white':
        colorClassName = 'white'
        break
      default:
        colorClassName = 'blue'
    }
    const htmlCode = `<div class="overlay overlay--${colorClassName}"></div>`
    whereThrow.addClass('overlay-active').append(htmlCode)
  },

  /**
   * [remove description]
   * @param  {[type]} whereThrow [description]
   * @return {[type]}            [description]
   */
  removeFrom (element) {
    element.removeClass('overlay-active').find('.overlay').remove()
  },
}

module.exports = Overlay



// WEBPACK FOOTER //
// ./src/modules/overlay.js